module.exports = __webpack_public_path__ + "assets/b31ab0e4092bf493abdbf53853afd757.png";